import Link from "next/link"
import { FaRegUser} from "react-icons/fa6"

const AccountButton = ({ className = "" }) => {
    const classes = [
        "inline-flex items-center justify-center rounded-full p-2 text-chocolate/90 transition-colors duration-200 hover:text-black",
        className,
    ].filter(Boolean).join(" ")

    return (
        <>
        {/* <button className="relative focus:outline-none focus:text-primary-900" aria-label="User account" onClick={() => {}} > */}
            <Link href="/store/account" className={classes}
                // className="h-10 w-auto hover:text-crimson transition duration-150 ease-in-out" 
                aria-label="Account"><FaRegUser className="h-6 w-6" />
           </Link>
        {/* </button> */}
        </>
    )
}

export default AccountButton
